import { FC } from "react";

const AccessDenied: FC = () => {
	return (
		<>
			<main
				className="relative top-0 md:top-16 left-0 w-full 2xl:max-w-[1440px] ml-auto mr-auto"
				data-testid="appTemplate-accessdenied"
			>
				<div className="w-full pt-[43px] pl-10 lg:pl-[90px]">
					<h3 className="font-bold text-foreground text-[42px]">
						You don&apos;t have permission to access this functionality.
					</h3>
				</div>
			</main>
		</>
	);
};

export default AccessDenied;
